var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaptiste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.8 263.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f7c310;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #833f26;\n      }\n\n      .cls-3 {\n        fill: #0f0e09;\n      }\n\n      .cls-4 {\n        fill: #bebbbb;\n      }\n\n      .cls-5 {\n        fill: #313b4c;\n      }\n\n      .cls-6 {\n        fill: #f49911;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #fdd6a8;\n      }\n\n      .cls-9 {\n        fill: #010101;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "159.08 161.58 178.28 161.58 178.28 170.13 187.89 170.13 187.89 235.75 169.14 235.75 169.14 217.74 178.27 217.74 178.27 207.41 169.27 207.41 169.27 197.91 159.08 197.91 159.08 161.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.7,
    y: 161.57,
    width: 93.68,
    height: 55.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "65.9 199.06 56.24 199.06 56.24 189.02 37.42 189.02 37.42 198.71 47.08 198.71 47.08 217.08 28.77 217.08 28.77 207.59 19.1 207.59 19.1 178.85 28.51 178.85 28.51 170.46 47.08 170.46 47.08 161.55 65.9 161.55 65.9 199.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 56.24,
    y: 199.07,
    width: 17.76,
    height: 27.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 47.26,
    y: 207.75,
    width: 20,
    height: 9.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 38.62,
    y: 226.18,
    width: 17.99,
    height: 9.32,
    transform: "translate(95.22 461.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.74,
    y: 220.99,
    width: 17.99,
    height: 10.1,
    transform: "translate(-182.3 269.78) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 28.46,
    y: 226.48,
    width: 18.76,
    height: 18.46,
    transform: "translate(-197.87 273.56) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.08,
    y: 217.08,
    width: 9.49,
    height: 9.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.56,
    y: 189.11,
    width: 9.49,
    height: 9.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 179.43,
    width: 9.49,
    height: 9.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 65.94,
    y: 217.01,
    width: 93.65,
    height: 9.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 132.07,
    y: 236.36,
    width: 45.56,
    height: 9.48,
    transform: "translate(395.95 86.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 47.9,
    y: 236.36,
    width: 45.56,
    height: 9.48,
    transform: "translate(311.78 170.42) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 56.38,
    y: 254.36,
    width: 19.04,
    height: 9.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 150.11,
    y: 254.36,
    width: 19.04,
    height: 9.51
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "193.68 30.22 29.36 30.22 29.36 104.89 53.14 104.89 53.14 129.19 170.16 129.19 170.16 104.89 193.68 104.89 193.68 30.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "29.58 81.33 29.58 23.33 41.58 23.33 41.58 11.33 65.14 11.33 65.14 0 158.69 0 158.69 12 182.03 12 182.03 23.56 193.8 23.56 193.8 81.33 182.03 81.33 182.03 46.67 170.03 46.67 170.03 34.22 88.03 34.22 88.03 46 53.14 46 53.14 56.67 41.58 56.67 41.58 81.33 29.58 81.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 53.78,
    y: 69.89,
    width: 22.76,
    height: 35.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.62,
    y: 69.43,
    width: 23.56,
    height: 35.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 65.88,
    y: 69.89,
    width: 10.67,
    height: 22.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 146.62,
    y: 69.5,
    width: 11.75,
    height: 23.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 88.07,
    y: 92.65,
    width: 47.24,
    height: 12.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 128.97,
    y: 111.31,
    width: 23.65,
    height: 10.73,
    transform: "translate(257.47 -24.11) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 70.92,
    y: 111.32,
    width: 23.65,
    height: 10.65,
    transform: "translate(199.39 33.9) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 24.29,
    y: 121.91,
    width: 46.22,
    height: 12.05,
    transform: "translate(175.34 80.53) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 152.95,
    y: 121.91,
    width: 46.22,
    height: 12.05,
    transform: "translate(303.99 -48.12) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 53.48,
    y: 128.47,
    width: 116.56,
    height: 33.98
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaptiste);
export default __webpack_public_path__ + "static/media/baptiste.87924b6b8c01fff4ed1948717780c9d6.svg";
export { ForwardRef as ReactComponent };